<div class="popup-comp">
  <div class="modal-header">
    <h4 class="modal-title" id="sanofiModalLabel">
      Items In Your Cart
    </h4>
  </div>

  <div class="modal-body">
    <p> Reserving influenza products will remove all items from your cart. How would you like to proceed?</p>
  </div>

  <div class="modal-footer">
    <div class="undo-changes-btngrps">
      <button id="proceedExPopup" type="button" class="btn-primary" (click)="influenzaPage()">
        Proceed to Influenza Vaccines
      </button>
      <button type="button" class="btn-secondary" (click)="redirectToDashboard();">
        Keep cart items and continue shopping
      </button>
    </div>
  </div>
</div>